import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Icon, Segment, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { Base64Image } from 'Common/Components';
import { formatToCash } from 'Common/FormHelper';
import { getIsDragging } from 'State/selectors';

import { MyPlate } from '../MyPlate/MyPlate';
import { Popup } from '../Popup/Popup';
import { NutritionalFacts } from '../NutritionalFacts/NutritionalFacts';
import {
  COMPONENTS,
  DATA_FIELDS as Fields,
  COMPONENT_TYPE,
} from './constants/constants';
import { IngredientGrid } from '../IngredientGrid/IngredientGrid';
import { getRecipe } from 'State/getrecipe/actions';
import { getRecipeData, getRecipeLoading } from 'State/getrecipe/selectors';
import {
  hasWholeValue,
  convertToMyPlate,
  getComponentMeasure,
} from './helpers/helpers';

import 'Styles/components/nutritionalHover.less';
class NutritionalHover extends Component {
  static propTypes = {
    getRecipe: PropTypes.func,
    loading: PropTypes.bool,
    showDisclaimer: PropTypes.bool,
    showServingCost: PropTypes.bool,
    data: PropTypes.shape({
      Picture: PropTypes.string,
      Id: PropTypes.string,
      Name: PropTypes.string,
      Description: PropTypes.string,
      NumberOfPortion: PropTypes.number,
      Calories: PropTypes.string,
      TotalFat: PropTypes.string,
      SaturatedFat: PropTypes.string,
      Cholesterol: PropTypes.string,
      Sodium: PropTypes.string,
      CarboHydrate: PropTypes.string,
      DietaryFiber: PropTypes.string,
      Sugars: PropTypes.string,
      Protein: PropTypes.string,
      Iron: PropTypes.string,
      Calcium: PropTypes.string,
      VitaminA: PropTypes.string,
      VitaminC: PropTypes.string,
      CostPerServing: PropTypes.number,
      QtyOfPortion: PropTypes.number,
      MeasureOfPortion: PropTypes.string,
      MeatAlt: PropTypes.string,
      Milk: PropTypes.string,
      DarkGreenVeg: PropTypes.string,
      Fruit: PropTypes.string,
      LegumesVeg: PropTypes.string,
      OtherVeg: PropTypes.string,
      AdditionalVeg: PropTypes.string,
      RedOrangeVeg: PropTypes.string,
      StarchyVeg: PropTypes.string,
      EnrichedGrain: PropTypes.string,
      WholeGrain: PropTypes.string,
      ComponentType: PropTypes.number,
      OtherComponent: PropTypes.string,
      IsCostValid: PropTypes.bool,
      Ingredients: PropTypes.arrayOf(
        PropTypes.shape({
          IsActive: PropTypes.bool,
          CN_Code: PropTypes.string,
          Description: PropTypes.string,
          ProductName: PropTypes.string,
          ManufactName: PropTypes.string,
          Contributions: PropTypes.string,
        })
      ),
    }),
    disableHover: PropTypes.bool,
    openDelay: PropTypes.number,
    closeDelay: PropTypes.number,
    openRecipe: PropTypes.func,
    hideBaseWeightField: PropTypes.bool,
  };

  static defaultProps = {
    data: {},
    getRecipe: null,
    loading: false,
    showDisclaimer: false,
    showServingCost: true,
    disableHover: false,
    openDelay: 0,
    closeDelay: 0,
    openRecipe: () => {},
    hideBaseWeightField: true,
  };

  getMyPlate = () => {
    const { data } = this.props;
    return convertToMyPlate(data);
  };

  getComponentRow = (name, value, componentType, key) => {
    if (value && value.length > 0) {
      const measure = getComponentMeasure(name);

      const dessertString =
        (name === COMPONENTS.WholeGrain &&
          componentType === COMPONENT_TYPE.Dessert) ||
        (name === COMPONENTS.EnrichedGrain &&
          componentType === COMPONENT_TYPE.Dessert)
          ? 'Dessert'
          : '';

      const juiceString =
        componentType === COMPONENT_TYPE.Juice &&
        (name.includes('Veg') || name.includes('Fruit'))
          ? 'Juice'
          : '';

      return (
        <div className="nutritional-row" key={key}>
          <div className="nutritional-column component-table left">
            {dessertString} {name} {juiceString}
          </div>
          <div className="nutritional-column component-table right">
            {value} {measure}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  getComponents = () => {
    return Object.keys(COMPONENTS).map((item, index) => {
      if (hasWholeValue(this.props.data[item])) {
        return this.getComponentRow(
          COMPONENTS[item],
          this.props.data[item],
          this.props.data[Fields.ComponentType],
          index
        );
      } else {
        return null;
      }
    });
  };

  openRecipe = (recipeId) => {
    const { openRecipe } = this.props;
    openRecipe(recipeId);
  };

  getContent = () => {
    const {
      data,
      loading,
      showDisclaimer,
      showServingCost,
      hideBaseWeightField,
    } = this.props;
    return (
      <Dimmer.Dimmable as={Segment} dimmed={loading} className="no-pad">
        <Dimmer active={loading} inverted>
          <Loader>Loading</Loader>
        </Dimmer>
        <div className="nutritional-hover">
          <div className="nutritional-hover-header">
            <div className="nutritional-row">
              <div className="nutritional-column item-description">
                {data[Fields.Description]}
              </div>
              <div className="nutritional-column item-id">
                <div onClick={() => this.openRecipe(data[Fields.Id])}>
                  {data[Fields.Id]}
                  &nbsp;
                  <Icon className="edit-icon" name="pencil" />
                </div>
              </div>
            </div>
          </div>
          <div className="nutritional-hover-body">
            <div className="nutritional-row">
              <div className="nutritional-column item-info picture">
                <div className="nutritional-image-description">
                  {data[Fields.Name]}
                </div>
                <Base64Image src={data[Fields.Picture]} alt="Recipe Image" />
                {showServingCost && (
                  <div className="nutritional-plate-cost">
                    Cost Per Serving :{' '}
                    {`$${formatToCash(data[Fields.CostPerServing])}`}
                    {!data[Fields.IsCostValid] && (
                      <div className="nutritional-plate-cost-incomplete">
                        Cost data incomplete
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="nutritional-column item-info facts">
                <NutritionalFacts
                  hideBaseWeightField={hideBaseWeightField}
                  data={data}
                />
              </div>
              <div className="nutritional-column item-info my-plate">
                <MyPlate selectedComponents={this.getMyPlate()} isSmallSize />
                <div className="nutritional-row">
                  <div className="nutritional-column component-table header left">
                    Component
                  </div>
                  <div className="nutritional-column component-table header right">
                    Amount
                  </div>
                </div>
                {this.getComponents()}
              </div>
            </div>
            {showDisclaimer && (
              <div className="nutritional-row">
                <div className="nutritional-column full-width disclaimer">
                  The nutrition information provided in this analysis should not
                  be used for people with a medical condition or food allergy.
                  Ingredients and menu items are subject to change or
                  substitution without notice. In planning and treating
                  allergies and medical conditions, please contact the district
                  regarding their individual policy for accommodating special
                  dietary needs.
                </div>
              </div>
            )}
            <div className="nutritional-row">
              <div className="nutritional-column full-width">
                <IngredientGrid data={data[Fields.Ingredients] || []} />
              </div>
            </div>
          </div>
        </div>
      </Dimmer.Dimmable>
    );
  };

  onOpen = (e, data) => {
    const { isDragging, getRecipe, recipeId } = this.props;
    //if getData function exists fetch the data for us
    //otherwise it'll be passed in for storyboooking
    if (getRecipe && !isDragging) {
      getRecipe(recipeId);
    }
  };

  render() {
    const {
      children,
      isDragging,
      disableHover,
      openDelay,
      closeDelay,
    } = this.props;

    const isDisabled = disableHover || isDragging;

    if (isDisabled) {
      return <div className="hover-container">{children}</div>;
    }

    return (
      <div className="hover-container">
        <Popup
          className="no-pad"
          trigger={children}
          position="left center"
          size="small"
          wide="very"
          hoverable
          hideOnScroll={false}
          onOpen={this.onOpen}
          onClose={this.onClose}
          openDelay={openDelay}
          closeDelay={closeDelay}
        >
          {this.getContent()}
        </Popup>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: getRecipeData(state),
  loading: getRecipeLoading(state),
  isDragging: getIsDragging(state),
});

const mapDispatchToProps = {
  getRecipe,
};

const NutritionalHoverConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(NutritionalHover);

export { NutritionalHover, NutritionalHoverConnected };



// WEBPACK FOOTER //
// ./src/common/Components/NutritionalHover/NutritionalHover.js